import React, { useMemo } from "react";
import { ReactionsPopover } from "./components";
import { useChatMessageBubble } from "../../providers/ChatMessageBubbleProvider/useChatMessageBubble";

export const Reactions: React.FC = () => {
  const { reactions } = useChatMessageBubble();

  const visibleReactions = useMemo(
    () => reactions?.summary?.slice(0, 5) || [],
    [reactions]
  );

  const allReactionsCount = useMemo(
    () =>
      reactions?.summary
        ?.map((item) => item.count)
        .reduce((a, b) => a + b, 0) || 0,
    [reactions]
  );

  if (!reactions) {
    return null;
  }

  return (
    <>
      <div className="absolute bottom-0 left-0 flex h-[26px] translate-y-5 items-center gap-1 rounded-xl bg-white px-1.5 py-1 shadow">
        {visibleReactions.map((item, idx) => (
          <ReactionsPopover
            key={item.reaction}
            reactionItem={item}
            moreReactions={idx === 4 && visibleReactions.length > 5}
            reactionsLength={visibleReactions.length}
          />
        ))}
        <span className="text-xs font-medium text-grey-600">
          {allReactionsCount}
        </span>
      </div>
    </>
  );
};
